import React, { useState, useEffect } from "react";
import { Tab, Tabs, Typography } from "@mui/material";
import CMCustomerNotesReport from "./AdministrationReports/CMCustomerNotesReport";
import PlanRenewalReport from "./AdministrationReports/PlanRenewalReport";
import ActiveCustomerReport from "./AdministrationReports/ActiveCustomerReport";
import TasksReport from "./AdministrationReports/TasksReport";
import ClientTerminationReport from "./AdministrationReports/ClientTerminationReport";
import ClientStatusReport from "./AdministrationReports/ClientStatusReport";
import CustomerContactsReport from "./AdministrationReports/CustomerContactsReport";

export default function AdministrationReports(props) {
    const [activeKey, setActiveKey] = useState('employeeNotes');

    const handleKeyChange = (event, activeKey) => {
        setActiveKey(activeKey);
    };

    useEffect(() => {
        setActiveKey(props.activeSubKey)
    }, [props.activeSubKey]);

    return (
        <div style={{ width: '100%', position: 'absolute' }}>
            <div>
                <Typography
                    style={{
                        fontWeight: "bold",
                        fontSize: "1.5rem",
                        fontFamily: "Lato",
                        marginBottom: 10,
                        marginLeft: 10
                    }}
                >
                    Administration Reports
                </Typography>
            </div>
            <div style={{ width: '100%' }}>
                <Tabs
                    value={activeKey}
                    onChange={handleKeyChange}
                    variant="scrollable"
                    sx={{
                        borderBottom: 1,
                        borderColor: 'divider',
                        '& .Mui-selected': {
                            backgroundColor: '#f0f0f0',
                            fontWeight: 'bold',
                            width: 'inherit'
                        }
                    }}
                >
                    {props.user.permissions.EmployeeNotesReport && <Tab key={"employeeNotes"} value={"employeeNotes"} label="Employee Notes" />}
                    {props.user.permissions.ClientTerminationReport && <Tab key={"clientTermination"} value={"clientTermination"} label="Client Termination" />}
                    {props.user.permissions.ClientStatusReport && <Tab key={"clientStatus"} value={"clientStatus"} label="Client Status" />}
                    {props.user.permissions.PlanRenewalReport && <Tab key={"planRenewal"} value={"planRenewal"} label="Plan Renewal" />}
                    {props.user.permissions.ActiveCustomerReport && <Tab key={"activeCustomer"} value={"activeCustomer"} label="Active Customer" />}
                    {props.user.permissions.TasksReport && <Tab key={"tasks"} value={"tasks"} label="Tasks" />}
                    {<Tab key={"customerContacts"} value={"customerContacts"} label="Customer Contacts" />}
                </Tabs>

                <div style={{ width: "100%" }}>
                    {activeKey === "clientTermination" && <ClientTerminationReport {...props} />}
                    {activeKey === "clientStatus" && <ClientStatusReport {...props} />}
                    {activeKey === "employeeNotes" && <CMCustomerNotesReport {...props} />}
                    {activeKey === "planRenewal" && <PlanRenewalReport {...props} />}
                    {activeKey === "activeCustomer" && <ActiveCustomerReport {...props} />}
                    {activeKey === "tasks" && <TasksReport {...props} />}
                    {activeKey === "customerContacts" && <CustomerContactsReport {...props} />}
                </div>
            </div>
        </div>
    )
};